// Companies service - moved from database.js
import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  serverTimestamp, 
  db 
} from '../../utils/database/firebase-config';

// Import chart of accounts service for default account initialization
import { chartOfAccountsService } from '../accounting/chart-of-accounts';
import { accountMappingService } from '../accounting/account-mapping';

export const companiesService = {
  async getCompanies() {
    const companiesRef = collection(db, 'companies');
    const querySnapshot = await getDocs(companiesRef);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  },
  async getCompany(companyId) {
    const companyRef = doc(db, 'companies', companyId);
    const companySnap = await getDoc(companyRef);
    if (companySnap.exists()) return { id: companySnap.id, ...companySnap.data() };
    throw new Error('Company not found');
  },
  async addCompany(companyData) {
    console.log('🏢 Creating new company with default accounts...');
    
    const companiesRef = collection(db, 'companies');
    const docRef = await addDoc(companiesRef, { 
      ...companyData, 
      createdAt: serverTimestamp(), 
      updatedAt: serverTimestamp() 
    });
    
    const companyId = docRef.id;
    console.log(`✅ Company created with ID: ${companyId}`);
    
    // 🚀 AUTOMATICALLY INITIALIZE DEFAULT CHART OF ACCOUNTS
    try {
      console.log('📊 Initializing default Chart of Accounts...');
      const accountsInitialized = await chartOfAccountsService.initializeDefaultChartOfAccounts(
        companyId, 
        companyData.createdBy || 'system'
      );
      
      if (accountsInitialized) {
        console.log('✅ Default Chart of Accounts initialized successfully');
        
        // Initialize default account mappings for automation
        try {
          console.log('🔗 Initializing account mappings...');
          await accountMappingService.initializeDefaultMappings(companyId, companyData.createdBy || 'system');
          console.log('✅ Account mappings initialized successfully');
        } catch (mappingError) {
          console.error('⚠️ Failed to initialize account mappings:', mappingError);
          // Don't fail company creation if mappings fail
        }
        
      } else {
        console.log('⚠️ Default accounts already exist or initialization skipped');
      }
    } catch (error) {
      console.error('❌ Failed to initialize default Chart of Accounts:', error);
      // Don't fail company creation if COA initialization fails
      // The user can manually initialize later via the UI
    }
    
    return companyId;
  },
  async updateCompany(companyId, companyData) {
    const companyRef = doc(db, 'companies', companyId);
    await updateDoc(companyRef, { ...companyData, updatedAt: serverTimestamp() });
    return true;
  },
  async deleteCompany(companyId) {
    const companyRef = doc(db, 'companies', companyId);
    await deleteDoc(companyRef);
    return true;
  }
}; 